import { QuoteService } from 'quote-domain-core';
import { EnumQuoteServiceSalesType } from 'quote-domain-core';
import { EnumQuoteServiceType } from 'quote-domain-core';
import {AbstractServiceCalculator, PricingModeEnum} from "../abstract-service-calculator";
import { QuoteServiceMergeStrategy } from '../../service/quote-service/quote-service-corridor-pipeline-service';

export class FonRenewalServiceCalculator extends AbstractServiceCalculator{

    constructor(public quoteService: QuoteService, public referential: any, public referentialServices: any, public mergeQuantity: boolean, public canChangePricingItemPrice: boolean, public pricingMode: PricingModeEnum) {
        super(quoteService, referential, referentialServices, mergeQuantity, canChangePricingItemPrice, pricingMode)
    }


    execute() {
        let referentialService = this.referentialServices.find((referential: any) => referential.serviceCode === EnumQuoteServiceType.FON);
        this.setupService.calculate(this.quoteService, this.referential);
        this.recommendedConsumableService.calculate(this.quoteService, this.referential);
        this.corridorPipelineService.execute(this.quoteService, this.referential, {
            mergeStrategy: this.mergeQuantity ? QuoteServiceMergeStrategy.ARTICLE_CODE : QuoteServiceMergeStrategy.BASE_QUANTITY,
            pricingMode: this.pricingMode,
            applySplitOnAppliedPrice: true
        });
        this.lifecycleService.applyGlobalDiscountAndRecalculate(this.quoteService);
        if (this.quoteService.salesType === EnumQuoteServiceSalesType.NEW) {
            this.commercialService.calculateExtraPrice(this.quoteService, referentialService, this.referential);
        }
        this.commercialService.calculateTheoreticalEffectif(this.quoteService, this.referential, 'ratioM/W');
        this.commercialService.calculateAdditionalConsumablePrice(this.quoteService, referentialService, this.referential);
        this.lifecycleService.complete(this.quoteService, { resetDistance: true, updateLastContractInfoInputs: true });
    }

}

